import request from '../utils/request'

// ==================== 文件上传 ====================

/**
 * 上传单张图片
 * @param {File} file - 图片文件
 * @param {String} path - 上传路径（可选）
 * @returns {Promise}
 */
export function uploadImage(file, path = 'admin/images') {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('path', path)
  
  return request({
    url: '/upload_controller/image',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

/**
 * 批量上传图片
 * @param {Array} files - 图片文件数组
 * @param {String} path - 上传路径（可选）
 * @returns {Promise}
 */
export function uploadImages(files, path = 'admin/images') {
  const formData = new FormData()
  files.forEach(file => {
    formData.append('files[]', file)
  })
  formData.append('path', path)
  
  return request({
    url: '/upload_controller/images',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

/**
 * 上传视频
 * @param {File} file - 视频文件
 * @param {String} path - 上传路径（可选）
 * @returns {Promise}
 */
export function uploadVideo(file, path = 'admin/videos') {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('path', path)
  
  return request({
    url: '/upload_controller/video',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

/**
 * 上传文件
 * @param {File} file - 文件
 * @param {String} path - 上传路径（可选）
 * @returns {Promise}
 */
export function uploadFile(file, path = 'admin/files') {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('path', path)
  
  return request({
    url: '/upload_controller/file',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

/**
 * 上传 Base64 图片
 * @param {String} base64Data - Base64 编码的图片数据
 * @param {String} path - 上传路径（可选）
 * @returns {Promise}
 */
export function uploadBase64Image(base64Data, path = 'admin/images') {
  return request({
    url: '/upload_controller/base64Image',
    method: 'post',
    data: {
      image: base64Data,
      path: path
    }
  })
}

/**
 * 删除文件
 * @param {String} path - 文件路径
 * @returns {Promise}
 */
export function deleteFile(path) {
  return request({
    url: '/upload_controller/delete',
    method: 'post',
    data: { path }
  })
}

/**
 * 获取文件信息
 * @param {String} path - 文件路径
 * @returns {Promise}
 */
export function getFileInfo(path) {
  return request({
    url: '/upload_controller/info',
    method: 'get',
    params: { path }
  })
}

/**
 * 富文本编辑器上传图片
 * @param {File} file - 图片文件
 * @returns {Promise}
 */
export function uploadEditorImage(file) {
  const formData = new FormData()
  formData.append('file', file)
  
  return request({
    url: '/upload_controller/editorImage',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

